import { render } from "./libraries.vue?vue&type=template&id=07988fc0&scoped=true"
import script from "./libraries.vue?vue&type=script&lang=js"
export * from "./libraries.vue?vue&type=script&lang=js"

import "./libraries.vue?vue&type=style&index=0&id=07988fc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07988fc0"]])

export default __exports__